import React from 'react'
import { Column } from 'primereact/column'
import ContributionTypeBodyTemplate from './ContributionTypeBodyTemplate'
import ContributionTypesDropdownEditor from './ContributionTypesDropdownEditor'
import { createColumnAttributes } from '../utils/createColumnAttributes'
import { getRowClassName } from '../utils/getRowClassName'

const ContributionTypeColumn = ({ title, mapsToField, filter, sortable, editable, isFieldChanged, isFieldChangedOverride, validationErrors, contributionTypes, originalData, editorCallbacksRef, dataKey, contactTypeIds, contributionTypeIds }) => {
    const { filterAttributes, sortAttributes, checkFieldChanged } = createColumnAttributes({
        filter,
        title,
        sortable,
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            body={(rowData) => (
                <span className={getRowClassName(checkFieldChanged, rowData)}>
                    <ContributionTypeBodyTemplate rowData={rowData} />
                </span>
            )}
            editor={editable ? (options) => <ContributionTypesDropdownEditor options={options} contributionTypes={contributionTypes} validationErrors={validationErrors} editorCallbacksRef={editorCallbacksRef} dataKey={dataKey} contactTypeIds={contactTypeIds} contributionTypeIds={contributionTypeIds} /> : null}
            {...filterAttributes}/>
    )
}

export default ContributionTypeColumn
